<template>
  <div class="rodemap">
    <WordDialog :key="index" :data="arr[index]" @jump="jump"></WordDialog>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';
import WordDialog from '../../cmp/wordDialog';

export default {
  data() {
    return {
      index: 0,
      arr: [
        {
          headImg: 'cv-04',
          word:
            '养性斋在整个御花园的西南边，最早建于明代，那时候叫乐志斋，清朝顺治时期才改的名。',
          audio: 'ytx',
          scene: 'scene4',
        },
        {
          headImg: 'cv-04',
          word: '你瞧，故宫总能吸引很多外国友人前来参观学习呢。',
          audio: 'ytx',
          scene: 'scene4_1',
        },
      ],
    };
  },
  components: {
    WordDialog,
  },
  created() {},
  computed: {},
  methods: {
    jump(event) {
      this.index += 1;
      if (this.arr.length === this.index) {
        this.$router.replace('/rodemap/ytx/04');
        this.index--;
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/养性斋.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
